import { Icon } from "../common/Icon";

export function NavIcon({ name }: { readonly name: string }) {
  return (
    <span className="nav-icon-shell" data-icon={name} aria-hidden="true">
      <Icon name={name} />
    </span>
  );
}
